interface Interface {
  title: string;
  icon?: string;
  link?: string;
  className?: string;
}

export default function Tag(attributes: Interface) {
  return (
    <a
      {...(attributes.link ? { href: attributes.link, target: "_blank", rel: "noreferrer" } : {})}
      className={
        "inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm " +
        "bg-gray-800/80 border border-gray-700/50 text-gray-300 " +
        "hover:border-gray-600 hover:text-white transition-all duration-200 " +
        attributes.className
      }
    >
      {attributes.icon && (
        <img
          alt={attributes.title}
          src={attributes.icon}
          className="w-4 h-4 object-contain shrink-0"
        />
      )}
      <span className="whitespace-nowrap">{attributes.title}</span>
    </a>
  );
}
